<template>
    <div class="content-body todo-list">
        <el-table
                :data="dataList"
                v-loading="dataListLoading"
                size="small"
                stripe
                @selection-change="selectionChangeHandle"
                :height="documentClientHeight"
                style="width: 100%;">
            <el-table-column
                    type="index"
                    width="50"
                    label="序号">
            </el-table-column>
            <el-table-column
                    prop="taskName"
                    header-align="left"
                    align="left"
                    label="名称">
            </el-table-column>
            <el-table-column
                    prop="processName"
                    header-align="left"
                    align="left"
                    label="相关流程">
            </el-table-column>
            <el-table-column
                    prop="createTime"
                    header-align="left"
                    align="left"
                    label="创建时间">
            </el-table-column>
            <el-table-column
                    header-align="left"
                    align="left"
                    width="300"
                    label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="executeHandle(scope.row)" icon="el-icon-edit">处理
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- <el-pagination
                @size-change="sizeChangeHandle"
                @current-change="currentChangeHandle"
                :current-page="pageIndex"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                :total="totalPage"
                layout="total, sizes, prev, pager, next, jumper">
        </el-pagination> -->
    </div>
</template>

<script>
    import { listMyToDo  } from '@/controller/workflow'
    import {listCodeApplyMyToDo} from '@/controller/supplier'
    export default {
        data() {
            return {
                documentClientHeight: document.documentElement['clientHeight'] - 250,
                dataForm: {
                    code: '',
                    name: ''
                },
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false,
                menuUpdateVisible: false
            }
        },
        components: {
        },
        activated() {
            this.listTenants()
        },
        methods: {
            executeHandle(row) {
                debugger
                console.log("row===="+row)
                // 定厂审批单
                if(row.processKey === 'FIX_POINT_APPROVE'){
                    this.$router.push('/sourcing-audit')
                }
                // 价格协议审批
                else if(row.processKey === 'PAT' || row.processKey === 'PAA'){
                    console.log("row.processKey===="+row.processKey)
                    this.$router.push('/sourcing-priceAgreement')
                }
                // 潜在供应商准入
                else if(row.processKey === 'PSA'){
                    this.$router.push('/supplier-admissionApplyForm')
                }
                // 合格供应商准入
                else if(row.processKey === 'QSA'){
                    this.$router.push('/supplier-admissionApplyForm2')
                }
                // 样件订单审批
                else if(row.processKey === 'SAMPLE_ORDER'){
                    this.$router.push('/sourcing-order')
                }
                // 供应商编码申请
                else if(row.processKey === 'SCA'){
                    this.$router.push('/supplier-qualifiedCodeApprove')
                }
                else if(row.processKey === 'SCA0'){
                    this.$router.push('/supplier-qualifiedCodeApply')
                }
                // 供应商变更审批
                else if(row.processKey === 'SCI'){
                    this.$router.push('/supplier-changeApprove')
                }
                // 供应商冻结审批
                else if(row.processKey === 'SUPPLIER_FREEZE'){
                    if(row.taskName === '提交供应商冻结申请'){
                        this.$router.push('/supplier-supplierInfo')
                    }else{
                        this.$router.push('/supplier-freezingThawApplyForm')
                    }
                }
                // 供应商解冻审批
                else if(row.processKey === 'SUPPLIER_THAW'){
                    if(row.taskName === '提交供应商解冻申请'){
                        this.$router.push('/supplier-supplierInfo')
                    }else{
                        this.$router.push('/supplier-thawApplyForm')
                    }
                }
                // 交货单审批
                else if(row.processKey === 'DOA'){
                    this.$router.push('/sop-delivery')
                }
            },
            // 获取数据列表
            listTenants() {
                this.dataListLoading = true
                listMyToDo({
                    'pageNo': this.pageIndex,
                    'pageSize': 1000,//this.pageSize,
                }).then(data => {
                    console.log(data)
                    if (data && data.code === '00') {
                        this.dataList = data.body.records
                        this.totalPage = data.body.total

                        listCodeApplyMyToDo({}).then(data => {
                            if(data && data.code === '00'){
                                if(data.body.length != 0){
                                    this.dataList = this.dataList.concat(data.body)
                                }
                            }
                        })

                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                    this.dataListLoading = false
                })
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.listTenants()
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                this.listTenants()
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            // 新增 / 修改
            addOrUpdateHandle(id) {
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(id)
                })
            },
            menuUpdateHandle(id) {
                this.menuUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.menuUpdate.init(id)
                })
            }
        }
    }
</script>